import React from 'react';
import { PanelHeader } from '@apply/components';
import { DemoPage } from './common/DemoLayout';

export const PanelHeaderDemo: React.FC = () => {
    return (
        <DemoPage title='Panel Header :'>
            <PanelHeader>Draws Mobile Header Panel</PanelHeader>
        </DemoPage>
    );
};
